import { Injectable, inject } from '@angular/core';
import { NgbDateParserFormatter, NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { format, parse } from 'date-fns';
import { enUS, enGB, nl, de, fr, fi, Locale } from 'date-fns/locale';
import { TranslateService } from '@ngx-translate/core';
import { getDateFormatForLang } from '@insolution/core-utils';

@Injectable({ providedIn: 'root' })
export class I18nDateParserFormatter extends NgbDateParserFormatter {
  private translateService = inject(TranslateService);

  private getLocale(): Locale {
    switch (this.translateService.getCurrentLang()) {
      case 'nl-NL':
        return nl;
      case 'de-DE':
        return de;
      case 'fr-FR':
        return fr;
      case 'fi-FI':
        return fi;
      case 'en-US':
        return enUS;
      case 'en-GB':
        return enGB;
      default:
        return enUS;
    }
  }

  public getFormat(): string {
    return getDateFormatForLang(this.translateService.getCurrentLang());
  }

  parse(value: string): NgbDateStruct | null {
    if (!value) return null;
    const parsed = parse(value, this.getFormat(), new Date(), {
      locale: this.getLocale(),
    });
    if (isNaN(parsed.getTime())) return null;
    return {
      day: parsed.getDate(),
      month: parsed.getMonth() + 1,
      year: parsed.getFullYear(),
    };
  }

  parseISO(value: string): NgbDateStruct | null {
    if (!value) return null;
    const parsed = parse(value, 'yyyy-MM-dd', new Date());
    if (isNaN(parsed.getTime())) return null;
    return {
      day: parsed.getDate(),
      month: parsed.getMonth() + 1,
      year: parsed.getFullYear(),
    };
  }

  format(date: NgbDateStruct | null): string {
    if (!date) return '';
    const d = new Date(date.year, date.month - 1, date.day);

    if (isNaN(d.getTime())) return '';

    return format(d, this.getFormat(), { locale: this.getLocale() });
  }

  ngbDateStructToISO(date: NgbDateStruct | null): string | null {
    if (!date) return null;

    const dateString = `${date.year}-${String(date.month).padStart(2, '0')}-${String(date.day).padStart(2, '0')}`;

    if (isNaN(new Date(dateString).getTime())) {
      return null;
    }

    return dateString;
  }
}
